(function () {
	Vue.component('nominow-customer-view', {
		props: {
			customer: {
				type: Object,
				required: true
			},
			parent: {
				type: Object,
				required: true,
				default: () => ({
					getGender: (val) => { return val },
					getLanguage: (val) => { return val },
					getCountry: (val) => { return val }
				})
			}
		},
		template: /*html*/`
        <div class="tile is-ancestor">
			<div class="tile is-parent">
				<div class="tile">
					<ul class="icon-list is-small">
						<li v-if="customer.Firstname || customer.Surname">
							<span class="icon has-text-centered">
								<i class="fa  fa-user" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{customer.Firstname}} {{customer.Surname}}</span>
						</li>
						<li v-if="customer.GenderId">
							<span class="icon has-text-centered">
								<i class="fa  fa-intersex" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{parent.getGender(customer.GenderId)}}</span>
						</li>
						<li v-if="customer.BirthDate">
							<span class="icon has-text-centered">
								<i class="fa  fa-calendar" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{ customer.BirthDate | formatDate }}</span>
						</li>
						<li v-if="customer.MobileNumber">
							<span class="icon has-text-centered">
								<i class="fa  fa-phone" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{customer.MobileNumber}}</span>
						</li>
						<li v-if="customer.EmailAddress">
							<span class="icon has-text-centered">
								<i class="fa  fa-envelope-o" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{customer.EmailAddress}}</span>
						</li>
						<li v-if="customer.LanguageId">
							<span class="icon has-text-centered">
								<i class="fa  fa-comment" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{parent.getLanguage(customer.LanguageId)}}</span>
						</li>
					</ul>
				</div>
				<div class="tile" v-if="customer.Street || customer.PostalCode || customer.City || customer.CountryId">
					<ul class="icon-list is-small">
						<li v-if="customer.Street">
							<span><span class="icon has-text-centered"><i class="fa  fa-map-marker" aria-hidden="true"></i></span></span>
							<span class="icon-label">{{customer.Street}} {{customer.HouseNumber}} {{customer.HouseNumberAdd}}</span>
						</li>
						<li v-if="customer.PostalCode">
							<span v-if="!customer.Street"><span class="icon has-text-centered"><i class="fa  fa-map-marker" aria-hidden="true"></i></span></span>
							<span class="icon-label">{{customer.PostalCode}}</span>
						</li>
						<li v-if="customer.City">
							<span v-if="!customer.Street && !customer.PostalCode"><span class="icon has-text-centered"><i class="fa  fa-map-marker" aria-hidden="true"></i></span></span>
							<span class="icon-label">{{customer.City}}</span>
						</li>
						<li v-if="customer.CountryId">
							<span v-if="!customer.Street && !customer.PostalCode && !customer.City"><span class="icon has-text-centered"><i class="fa  fa-map-marker" aria-hidden="true"></i></span></span>
							<span class="icon-label">{{parent.getCountry(customer.CountryId)}}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
        `
	});

	Vue.component('nominow-customer-code-view', {
		props: {
			customer: {
				type: Object,
				required: true
			},
			parent: {
				type: Object,
				required: true,
				default: () => ({
					getGender: (val) => { return val; },
					getLanguage: (val) => { return val; },
					getCountry: (val) => { return val; }
				})
			}
		},
		template: `
        <div class="tile is-ancestor">
			<div class="tile is-parent">
				<div class="tile">
					<ul class="icon-list is-small">
						<li v-if="customer.Firstname || customer.Surname">
							<span class="icon has-text-centered">
								<i class="fa  fa-user" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{customer.Firstname}} {{customer.Surname}}</span>
						</li>
						<li v-if="customer.GenderCode">
							<span class="icon has-text-centered">
								<i class="fa  fa-intersex" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{parent.getGender(customer.GenderCode)}}</span>
						</li>
						<li v-if="customer.BirthDate">
							<span class="icon has-text-centered">
								<i class="fa  fa-calendar" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{ customer.BirthDate | formatDate }}</span>
						</li>
						<li v-if="customer.MobileNumber">
							<span class="icon has-text-centered">
								<i class="fa  fa-phone" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{customer.MobileNumber}}</span>
						</li>
						<li v-if="customer.EmailAddress">
							<span class="icon has-text-centered">
								<i class="fa  fa-envelope-o" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{customer.EmailAddress}}</span>
						</li>
						<li v-if="customer.LanguageCode">
							<span class="icon has-text-centered">
								<i class="fa  fa-comment" aria-hidden="true"></i>
							</span>
							<span class="icon-label">{{parent.getLanguage(customer.LanguageCode)}}</span>
						</li>
					</ul>
				</div>
				<div class="tile" v-if="customer.Street || customer.PostalCode || customer.City || customer.CountryCode">
					<ul class="icon-list is-small">
						<li v-if="customer.Street">
							<span><span class="icon has-text-centered">
<i class="fa  fa-map-marker" aria-hidden="true"></i>
</span></span>
							<span class="icon-label">{{customer.Street}} {{customer.HouseNumber}} {{customer.HouseNumberAdd}}</span>
						</li>
						<li v-if="customer.PostalCode">
							<span v-if="!customer.Street"><span class="icon has-text-centered">
<i class="fa  fa-map-marker" aria-hidden="true"></i>
</span></span>
							<span class="icon-label">{{customer.PostalCode}}</span>
						</li>
						<li v-if="customer.City">
							<span v-if="!customer.Street && !customer.PostalCode"><span class="icon has-text-centered">
<i class="fa  fa-map-marker" aria-hidden="true"></i>
</span></span>
							<span class="icon-label">{{customer.City}}</span>
						</li>
						<li v-if="customer.CountryCode">
							<span v-if="!customer.Street && !customer.PostalCode && !customer.City"><span class="icon has-text-centered">
<i class="fa  fa-map-marker" aria-hidden="true"></i>
</span></span>
							<span class="icon-label">{{parent.getCountry(customer.CountryCode)}}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
        `
	});
})();
